import NetworkUtil from "./NetworkUtil";
import Facility, {FacilitySearch} from "../types/Facility";
import {ServerResponse} from "../types/ServerResponse";
import {ImportPreviewResponse, ImportConfirmResponse} from "../types/FacilityImport";

export class FacilityAPI{

    public static facilitySearch(filter, page):Promise<{num_pages:number, table_data?:FacilitySearch[],  data:FacilitySearch[]}>{
        return NetworkUtil.makePost("/api/admin/searchFacility?page=" + page, filter);
    }

    public static facilityUpsert(facility:Facility):Promise<ServerResponse>{
        return NetworkUtil.makePost("/api/admin/facilityUpsert", {facility: facility});
    }

    // after PaymentAPI.createCustomerProfile() we FacilityAPI.addANetProfileToFacility
    public static addANetCustomerProfileIDs({facilityID, aNetIDs}):Promise<{success:boolean,reason:string,data:Facility}>{
        return NetworkUtil.makePost("/api/admin/addANetProfileToFacility", {facilityID: facilityID, aNetIDs: aNetIDs});
    }

    public static facilityImportPreview(file: File, facilityType: string, action: string): Promise<ImportPreviewResponse> {
        let data = new FormData();
        data.set('file', file);
        data.set('facilityType', facilityType);
        data.set('action', action);
        return NetworkUtil.postForm("/api/admin/facilities/importPreview", data);
    }

    public static facilityImportConfirm(sessionId: string): Promise<ImportConfirmResponse> {
        return NetworkUtil.makePost("/api/admin/facilities/importConfirm", {sessionId});
    }

    public static facilityImportProgress(sessionId: string, cleanup: boolean = false): Promise<any> {
        return NetworkUtil.makeGet("/api/admin/facilities/importProgress?sessionId=" + sessionId + "&cleanup=" + cleanup);
    }
}